@if (resource.isLoading()) {
  <ui-configurable-bundles-skeleton></ui-configurable-bundles-skeleton>
} @else if (resource.error()) {
  <div class="wrapper-error">
    <ui-alert
      theme="error"
      message="Beim Laden des konfigurierbaren Pakets ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut. Oder Kontaktieren Sie unseren Kundenservice, falls das Problem weiterhin besteht."
    ></ui-alert>
  </div>
} @else if (resource.value(); as value) {
  <ui-configurable-bundle-form
    (addToCart)="addToCart($event)"
    [cartItem]="cartItem()"
    [bundleTemplate]="value"
    [isAddToCartLoading]="isAddToCartLoading()"
  ></ui-configurable-bundle-form>
}
